/**
 * 触摸事件模拟器
 * 用于在 PC 环境下模拟移动端的触摸事件
 */
function touchEmulator() {
  // 检查是否已经初始化
  if (window.__touchEmulatorInitialized) {
    return
  }
  window.__touchEmulatorInitialized = true

  // 鼠标事件类型映射到触摸事件类型
  const mouseToTouchMap = {
    mousedown: 'touchstart',
    mousemove: 'touchmove',
    mouseup: 'touchend'
  }

  // 模拟触摸点
  let touchPoint = null

  // 监听鼠标事件
  document.addEventListener('mousedown', function(e) {
    // 创建触摸点
    touchPoint = {
      identifier: Date.now(),
      clientX: e.clientX,
      clientY: e.clientY,
      pageX: e.pageX,
      pageY: e.pageY,
      screenX: e.screenX,
      screenY: e.screenY,
      target: e.target,
      // 模拟触摸点的其他属性
      radiusX: 2.5,
      radiusY: 2.5,
      rotationAngle: 0,
      force: 1
    }

    // 触发 touchstart 事件
    const touchStartEvent = createTouchEvent('touchstart', [touchPoint], e)
    e.target.dispatchEvent(touchStartEvent)
  })

  document.addEventListener('mousemove', function(e) {
    if (!touchPoint) return

    // 更新触摸点位置
    touchPoint.clientX = e.clientX
    touchPoint.clientY = e.clientY
    touchPoint.pageX = e.pageX
    touchPoint.pageY = e.pageY
    touchPoint.screenX = e.screenX
    touchPoint.screenY = e.screenY

    // 触发 touchmove 事件
    const touchMoveEvent = createTouchEvent('touchmove', [touchPoint], e)
    e.target.dispatchEvent(touchMoveEvent)
  })

  document.addEventListener('mouseup', function(e) {
    if (!touchPoint) return

    // 触发 touchend 事件
    const touchEndEvent = createTouchEvent('touchend', [], e)
    e.target.dispatchEvent(touchEndEvent)

    // 重置触摸点
    touchPoint = null
  })

  // 创建触摸事件
  function createTouchEvent(type, touches, mouseEvent) {
    const event = new Event(type, {
      bubbles: true,
      cancelable: true
    })

    // 添加触摸事件特有的属性
    event.touches = touches
    event.targetTouches = touches
    event.changedTouches = touches

    // 复制鼠标事件的属性
    event.clientX = mouseEvent.clientX
    event.clientY = mouseEvent.clientY
    event.pageX = mouseEvent.pageX
    event.pageY = mouseEvent.pageY
    event.screenX = mouseEvent.screenX
    event.screenY = mouseEvent.screenY
    event.preventDefault = function() {
      mouseEvent.preventDefault()
    }
    event.stopPropagation = function() {
      mouseEvent.stopPropagation()
    }

    return event
  }

  // 模拟 ontouchstart 属性
  if (!('ontouchstart' in window)) {
    Object.defineProperty(window, 'ontouchstart', {
      value: null,
      writable: true
    })
  }
}

export default touchEmulator
